<ng-template #Child>
  <ng-content></ng-content>
</ng-template>

<ng-template #Data let-change="change">
  <rspl-card [cardTitle]="change.user">
    <div fxLayout="column" class="history-data-wrapper">
      <table class="static-table full-width">
        <thead>
          <tr>
            <th>{{ change.oneValue ? '' : 'Changed' }}</th>
            @if (!change.oneValue) {
              <th>From</th>
            }
            @if (!change.oneValue) {
              <th>To</th>
            }
            @if (initialValue && initialEvent && change.event !== initialEvent) {
              <th class="initial"></th>
            }
            @if (change.oneValue) {
              <th>Value</th>
            }
            @if (initialValue && initialEvent && change.event !== initialEvent) {
              <th>{{ initialValueLabel() }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (field of change.fields; track field) {
            <tr>
              <td>{{ field.name }}</td>
              @if (!change.oneValue) {
                <td>
                  <p [innerHTML]="field.oldValue"></p>
                </td>
              }
              <td>
                <p [innerHTML]="field.newValue"></p>
              </td>
              @if (initialValue && initialEvent && change.event !== initialEvent) {
                <td class="initial"></td>
              }
              @if (initialValue && initialEvent && change.event !== initialEvent) {
                <td>
                  <p [innerHTML]="initialValue[field.name]"></p>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </rspl-card>
</ng-template>
@if (filterOptions() && showFilter()) {
  <rspl-card class="history-filters">
    <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-md="column" fxLayoutAlign="center center">
      <rspl-searchable-select [options]="filterOptions()" (filterChange)="filterChange($event)" fxFlex />
      @if (customFilterTemplate()) {
        <ng-container [ngTemplateOutlet]="customFilterTemplate()"></ng-container>
      }
    </div>
  </rspl-card>
}
<div class="history-wrapper">
  <div style="margin-bottom: 5px" fxLayout="row" fxLayoutAlign="space-between start">
    @if (showSort()) {
      <button mat-raised-button (click)="changeSort()">
        <span fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="center center">
          Sort
          <mat-icon style="min-width: 15px; position: relative">{{ sort() === 'asc' ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
        </span>
      </button>
    }
    @if (showExpandToggle()) {
      <button mat-raised-button (click)="toggleAllPanels(!hasExpandedPanel())">
        <span fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="center center">
          {{ hasExpandedPanel() ? 'Collapse All' : 'Expand All' }}
          <mat-icon style="min-width: 15px; position: relative">{{ hasExpandedPanel() ? 'expand_less' : 'expand_more' }}</mat-icon>
        </span>
      </button>
    }
  </div>
  <!-- @if (smallWindows.includes(windowSize)) { -->
  <div [fxLayout]="sort() === 'asc' ? 'column' : 'column-reverse'" fxFlex>
    <ng-container [ngTemplateOutlet]="Child"></ng-container>
    <mat-accordion [multi]="true">
      @for (change of sortedChanges; track change) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ change.event }}
            </mat-panel-title>
            <mat-panel-description>
              {{ change.time }}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ng-container [ngTemplateOutlet]="Data" [ngTemplateOutletContext]="{ change: change }"></ng-container>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <!-- } -->

  <!-- @if (!smallWindows.includes(windowSize)) {
    <div [fxLayout]="sort() === 'asc' ? 'column' : 'column-reverse'" fxFlex [ngClass]="{ 'history-vertical-wrapper': !isChild() }">
      <ng-container [ngTemplateOutlet]="Child"></ng-container>
      <div class="history">
        <div class="separator"></div>
        @for (change of sortedChanges; track change) {
          <div class="timeline-entry">
            <p class="date">{{ change.time }}</p>
            <p class="event">{{ change.event }}</p>
            <ng-container [ngTemplateOutlet]="Data" [ngTemplateOutletContext]="{ change: change }"></ng-container>
          </div>
        }
      </div>
    </div>
  } -->
</div>
